import { CodedError } from './CodedError';
import { errorCodes } from './constants/errorCodes';

export default class OAuthConfigError extends CodedError {
  static get errorName() {
    return errorCodes.oAuthConfigError.code;
  }

  constructor(message: string = errorCodes.oAuthConfigError.message) {
    super(message);
    this.code = errorCodes.oAuthConfigError.code;
    this.message = `${message} ${errorCodes.oAuthConfigError.code}`;
    this.name = errorCodes.oAuthConfigError.name;
    this.status = errorCodes.oAuthConfigError.status;
  }
}
